import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    background-image: ${({ theme }) => theme.profilePhotoInfo.gradient};
  }
`;

export const Photo = styled.div`
  margin-top: 32px;
  width: 120px;
  height: 120px;
  box-shadow: 0 2px 4px 0 rgba(${ColorPalette.RGB.Black}, 0.3);
  border: ${({ theme }) => theme.profilePhotoInfo.border};
  border-radius: 50%;

  & > img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
`;

export const DefaultPhoto = styled.div`
  margin-top: 32px;
  width: 120px;
  height: 120px;

  & > img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
`;

export const EditPhoto = styled.button`
  user-select: none;
  background: ${ColorPalette.Transparent};

  & > label {
    cursor: pointer;
    max-width: 120px;
    font-family: Poppins;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: 0.2px;
    text-align: center;
    color: ${({ theme }) => theme.profilePhotoInfo.editButton};
  }

  & > input {
    display: none;
  }
`;

export const Name = styled.label`
  min-height: 32px;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  letter-spacing: -0.4px;
  text-align: center;
  margin-top: 16px;
  padding: 0 16px;
  color: ${({ theme }) => theme.profilePhotoInfo.textColor};
`;

export const Email = styled.label`
  min-height: 24px;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: center;
  margin-top: 4px;
  padding: 0px;
  margin-bottom: 32px;
  color: ${({ theme }) => theme.profilePhotoInfo.textColor};
`;

export const Line = styled.div`
  margin: 0px 16px 39px 16px;
  height: 1px;
  border-bottom: solid 1px ${ColorPalette.HEX.BrightGray};
`;
